<template>
  <div>
    <base-header class="pb-0" type="pink">
      <b-row align-v="center" class="py-3">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">Documents</h6>
          <nav aria-label="breadcrumb" class="d-none d-sm-inline-block ml-sm-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>

        <!-- Show/Hide Filter Buttons -->
        <b-col lg="6" cols="5" class="text-right">
          <base-button v-if="showFilters" size="sm" type="neutral" @click="showFilters = !showFilters">Ocultar Filtros</base-button>
          <base-button v-if="!showFilters" size="sm" type="neutral" @click="showFilters = !showFilters">Mostrar Filtros</base-button>
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid>

      <!-- Filters -->
      <div :class="{ 'document-filters': showFilters, 'document-filters-hidden' : !showFilters }">
        <b-form inline>

          <b-form-select id="filter-difficulty" class="mb-2 mr-sm-2 mb-sm-0" :options="dateOrderOptions" v-model="selectedDateOrder" @change="filterDocuments"></b-form-select>          
          
        </b-form>
      </div>

      <!-- Document Grid -->
      <div v-if="documentsFetched.status">
        <documents-grid :documents="filteredDocuments.slice((currentPage - 1)*perPage, currentPage*perPage)"></documents-grid>
        <b-pagination align="center" v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
      </div>

      <div v-if="!documentsFetched.status" class="d-flex justify-content-center py-8">
        <div class="d-flex flex-column text-center text-muted">
          <div><i class="fas fa-spinner fa-spin display-1"></i></div>
          <div>Cargando</div>
        </div>
      </div>


    </b-container>


  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import DocumentsGrid from './Components/DocumentsGrid'
import db from '@/firebase/init'
import { documentStorage } from '@/store/documents.js'

export default {
  components: {
    RouteBreadCrumb,
    DocumentsGrid
  },
  data() {
    return {
      documents: documentStorage.state.documents,
      documentsFetched: documentStorage.state.documentsFetched,
      filteredDocuments: [],
      currentPage: 1,
      perPage: 4,
      responseReceived: false,
      showFilters: false,
      dateOrderOptions: [
        { text: 'Fecha de Subida', value: null},
        { text: 'Más Nuevos', value: false},
        { text: 'Más Antigüos', value: true}
      ],
      selectedDifficulty: null,
      selectedLength: null,
      selectedTools: null,
      selectedDateOrder: null,
    }
  },
  methods: {
    filterDocumentCategory(document) {
      if (this.$route.params.cat === 'all' || this.$route.params.cat === null) { return true }
      else { return document.category === this.$route.params.cat }
    },
    filterDocumentDifficulty(document) {
      if (this.selectedDifficulty === 'all' || this.selectedDifficulty === null) { return true }
      else { return document.difficulty === this.selectedDifficulty }
    },
    filterDocumentLength(document) {
      if (this.selectedLength === 'all' || this.selectedLength === null) { return true }
      else { return document.length === this.selectedLength }
    },
    filterDocumentTools(document) {
      if (this.selectedTools === 'all' || this.selectedTools === null) { return true }
      else { return document.tools === this.selectedTools }
    },
    uploadFilterSort() {
      if (this.selectedDateOrder === null || this.selectedDateOrder === false) {
        return function(a,b) {
          let dateA = new Date(a.uploadDate)
          let dateB = new Date(b.uploadDate)
          if (dateA > dateB) { return -1 }
          else if (dateA < dateB) { return 1 }
          else { return 0 }
        }
      }
      else {
        return function(a,b) {
          let dateA = new Date(a.uploadDate)
          let dateB = new Date(b.uploadDate)
          if (dateA > dateB) { return 1 }
          else if (dateA < dateB) { return -1 }
          else { return 0 }
        }
      }
    },
    clearFilters() {
      this.selectedDateOrder = null
    },
    filterDocuments() {
      this.currentPage = 1
      this.filteredDocuments = this.documents.filter(document => this.filterDocumentCategory(document))
        .slice(0).sort(this.uploadFilterSort())
    },
    fetchAllDocuments() {
      db.collection('documents').get()
        .then((snapshot) => {
          snapshot.forEach(doc => {
            let document = doc.data()
            document.id = doc.id
            this.documents.push(document)
          })
        })
    }
  },
  computed: {
    showFiltered() {
      return this.documents.filter(document => this.filterDocumentCategory(document))
        .slice(0).sort(this.uploadFilterSort())
    },
    rows() {
      return this.filteredDocuments.length
    }
  },
  async mounted() {
    // this.fetchAllDocuments()
    await documentStorage.fetchAllDocuments()
    this.filterDocuments()
  },
  watch: {
    '$route.params.cat' (to, from) {
      this.clearFilters()
      this.filterDocuments()
    }
  }
}
</script>

<style>

/* Document Filters */
.document-filters {
  display: flex;
  width: 100%;
  margin-top: 2rem;
  justify-content: center;
  transition: 0.2s;
}

.document-filters-hidden {
  display: flex;
  width: 100%;
  margin-top: 2rem;
  justify-content: center;
  max-height: 0;
  transform: scale(0);
  transition: 0.1s;
}

</style>